import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-cream py-14 sm:py-20" data-id="element-62" data-mp="13d4fiklb3xpu">
      <div className="mx-auto max-w-6xl px-5" data-id="element-63" data-mp="13bkzmv3kbool">
        <div className="text-center" data-id="element-64" data-mp="ydrum5dzx0pw">
          <SectionTag data-id="element-65" data-mp="ycqfnptuzu2w">5 bonos incluidos</SectionTag>
          <h2 className="mx-auto mt-4 max-w-[22ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[34ch] sm:text-[2.4rem]" data-id="element-66" data-mp="tg00d4pvp2ij">
            No te damos “5 PDFs más”. Te damos <span className="text-gold" data-id="element-67" data-mp="kg370psjnfh5">5 herramientas</span> para
            destrabar los pasos que vienen después.
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-68" data-mp="fibfvxzq3xe0">
          {BONOS.map((bono, i) => <motion.article key={bono.num} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.05
        }} className="flex h-full flex-col overflow-hidden rounded-3xl border border-stone bg-white shadow-[0_18px_40px_-30px_rgba(56,37,34,0.6)]" data-id="element-69" data-mp="29tzx66tfgc1k" data-mpi={i}>
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-sand" data-id="element-70" data-mp="mvx68lc66ew9">
                {bono.cover && <img src={bono.cover} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-71" data-mp="1ekz74x4xs1rl" />}
                <span className="absolute left-3 top-3 rounded-full bg-white/95 px-2.5 py-1 font-display text-[0.6rem] font-bold uppercase tracking-[0.12em] text-charcoal" data-id="element-72" data-mp="15r42dq7q8dch">
                  Bono {bono.num}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-gold px-2.5 py-1 font-display text-[0.6rem] font-bold uppercase tracking-[0.12em] text-white" data-id="element-73" data-mp="1yasv104j5wqj">
                  Incluido
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-74" data-mp="1y694irqywmj9">
                <h3 className="font-display text-[1.02rem] font-bold leading-snug tracking-tight text-charcoal" data-id="element-75" data-mp="1y8vd8uplh832">
                  {bono.name}
                </h3>
                <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-taupe" data-id="element-76" data-mp="1p6vx04mem816">
                  {bono.desc}
                </p>
              </div>
            </motion.article>)}

          <div className="flex h-full flex-col justify-center rounded-3xl bg-sand p-6 ring-1 ring-stone" data-id="element-77" data-mp="1fh2k90aizmvc">
            <p className="font-display text-[1.3rem] font-extrabold leading-tight tracking-tight text-charcoal" data-id="element-78" data-mp="1airb6rs21ge6">
              Los 5 bonos forman parte del precio.
            </p>
            <p className="mt-3 font-sans text-[0.87rem] leading-relaxed text-taupe" data-id="element-79" data-mp="11hkrk9u3zpgp">
              No se venden por separado ni se suman al final: vienen incluidos en la compra de
              Postres que Venden™.
            </p>
            <CTAButton className="mt-5 w-full px-4" label="LOS QUIERO TODOS" data-id="element-80" data-mp="3h3nceygx42w9" />
          </div>
        </div>
      </div>
    </section>;
}